// extracted by mini-css-extract-plugin
export default {"item":"PostItem_item__ttdBI","image":"PostItem_image__+1Usz","content":"PostItem_content__VfDbC","actions":"PostItem_actions__Kpbaz"};